const API_URL = 'https://lyfy.ltd';

export interface Application {
  id: number;
  full_name: string;
  email: string;
  github_url: string | null;
  linkedin_url: string | null;
  experience: string;
  motivation: string;
  status: 'pending' | 'approved' | 'rejected';
  created_at: string;
  admin_key: string | null;
}

export const applicationService = {
  getApplications: async () => {
    try {
      const response = await fetch(`${API_URL}/manage_applications.php?action=list`);
      const data = await response.json();
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error('Error fetching applications:', error);
      return [];
    }
  },

  approveApplication: async (id: number) => {
    try {
      const response = await fetch(`${API_URL}/manage_applications.php?action=approve&id=${id}`);
      return await response.json();
    } catch (error) {
      console.error('Error approving application:', error);
      return { success: false, message: 'Failed to approve application' };
    }
  },

  rejectApplication: async (id: number) => {
    try {
      const response = await fetch(`${API_URL}/manage_applications.php?action=reject&id=${id}`);
      return await response.json();
    } catch (error) {
      console.error('Error rejecting application:', error);
      return { success: false, message: 'Failed to reject application' };
    }
  }
}; 